enum LOCALE {
    BG = 'bg',
    EN = 'en',
}

export { LOCALE };
